import { includes, values } from 'lodash/fp';

import { DATASET, MIDDAY, MODE, NOW } from '../constants';
import CMS_UPDATE_PREVIEW_OPTIONS from '../action-types';

const initialState = () => ({
  apiToken: null,
  asAtDate: NOW,
  asAtTime: MIDDAY,
  dataset: DATASET.PRODUCTION,
  liveFilteringToken: null,
  mode: MODE.PUBLISHED,
});

export default function cms(state = initialState(), action = {}) {
  const reducers = {
    [CMS_UPDATE_PREVIEW_OPTIONS]: () => {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'payload' does not exist on type '{}'.
      const dataset = action?.payload?.dataset;
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'payload' does not exist on type '{}'.
      const mode = action?.payload?.mode;
      return {
        ...state,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'payload' does not exist on type '{}'.
        apiToken: action?.payload?.apiToken || state.apiToken,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'payload' does not exist on type '{}'.
        asAtDate: action?.payload?.asAtDate || state.asAtDate,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'payload' does not exist on type '{}'.
        asAtTime: action?.payload?.asAtTime || state.asAtTime,
        dataset: includes(dataset, values(DATASET)) ? dataset : state.dataset,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'payload' does not exist on type '{}'.
        liveFilteringToken: action?.payload?.liveFilteringToken || state.liveFilteringToken,
        mode: includes(mode, values(MODE)) ? mode : state.mode,
      };
    },
  };

  // @ts-expect-error - Automatic, Please fix when editing this file
  return reducers[action.type] ? reducers[action.type as keyof typeof reducers]() : state;
}
